import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import analytics from "../../utils/analytics";

const PAGE_TITLES = {
  "/": "Home | TechWorth TrueSelfy",
  "/signin": "Sign In | TechWorth TrueSelfy",
  "/skills-calculation": "Salary Calculator | TechWorth TrueSelfy",
  "/pricing": "Pricing & Plans | TechWorth TrueSelfy",
  "/contact-us": "Contact Us | TechWorth TrueSelfy",
  "/changelog": "Change Log | TechWorth TrueSelfy",
  "/incognito": "Incognito Mode | TechWorth TrueSelfy",
  "/tech-relevance": "Tech Relevance | TechWorth TrueSelfy",
  "/referrals": "Referrals | TechWorth TrueSelfy",
  "/previous-result": "Previous Results | TechWorth TrueSelfy",
  "/refund-policy": "Refund Policy | TechWorth TrueSelfy",
  "/my-friends": "My Friends | TechWorth TrueSelfy",
  "/endorse-expertise": "Endorse Expertise | TechWorth TrueSelfy",
  "/reassess-techvalue": "Reassess Tech Worth | TechWorth TrueSelfy",
  "/resume-ranker": "Resume Ranker | TechWorth TrueSelfy",
  "/trueselfy-admin": "Admin Panel | TechWorth TrueSelfy",
};

/**
 * Get human-readable page title for any pathname
 */
export const getPageTitle = (pathname) => {
  if (PAGE_TITLES[pathname]) {
    return PAGE_TITLES[pathname];
  }
  if (pathname.startsWith("/result/")) {
    return "Calculation Result | TechWorth TrueSelfy";
  }
  if (pathname.startsWith("/public-result/")) {
    return "Shared Result | TechWorth TrueSelfy";
  }
  return "TechWorth TrueSelfy";
};

/**
 * Global SPA Route Tracker
 * Automatically tracks pageviews and updates document.title on every route navigation
 */
const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const fullPath = location.pathname + location.search;
    const title = getPageTitle(location.pathname);

    // Update browser title
    document.title = title;

    // Dispatches normalized GA4 page_view
    analytics.pageView(fullPath, title);
  }, [location.pathname, location.search]);

  return null;
};

export default RouteTracker;
